<template>
  <div>
    <div class="container">
      <div class="columns">
        <div class="column">
          <ticketForm></ticketForm>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ticketForm from "@/components/support/TicketForm.vue";
import { mapState } from "vuex";
import { CourseClient } from "../clients/CourseClient";

export default {
  name: "Tasks",

  components: {
    ticketForm
  },

  data() {
    return {
      projects: []
    };
  },

  computed: {},
  mounted() {},

  methods: {}
};
</script>


